// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { currency, generateId, shortHandDateTime } from '../../_common/api/utility';
import Button from '../../_common/form/Button';
import Icon from '../../_common/form/Icon';
import Loading from '../../_common/Loading';
import Modal from '../../_common/Modal';
import Card from '../Card';
import MenuRoutes from '../MenuRoutes';
import { HamQuest } from '../../../App';

const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`
const Col = styled.div`
    display: flex;
    flex-direction: column;
`
const Row = styled.div`
    display: flex;
    justify-content: space-between;
`
const LineBreak = styled.div`
    display: flex;
    margin: 1em 0.3em;
    border-top: 1px solid ${({ theme }) => theme.mobile.primary};
`
const Indent = styled(Row)`
    margin: 0 0.5em;
`
const SubText = styled(Indent)`
    font-size: 0.7em;
`

const PurchaseHistory = ({ ...props }) => {

    const [history, setHistory] = useState(null)

    useEffect(() => {
        HamQuest.get(QuestRoute.user.purchaseHistory)
            .then(res => setHistory(res))
            .catch(ex => {
                Modal.Show({
                    type: 'error',
                    title: 'Unable to get History',
                    body: 'Sorry, something went wrong. Please try again.'
                })
            })
    }, [])

    const routes = MenuRoutes();

    if (!history) return <Loading />;

    return (
        <Card icon='history' title='Purchase History'>
            {
                history.length ?
                    <>
                        {history
                            .sort((a, b) => new Date(b.purchaseDate) - new Date(a.purchaseDate))
                            .map(e =>
                                <CardWrapper key={generateId()}>
                                    <Row>
                                        <div>{shortHandDateTime(e.purchaseDate)}</div>
                                        <div>{currency.format(e.total)}</div>
                                    </Row>
                                    {e.purchasedProducts
                                        .sort((a, b) => new Date(b.quantity) - new Date(a.quantity))
                                        .map(f => (
                                            <Indent key={generateId()}>
                                                <Col style={{ flex: 2 }}>
                                                    <div>• {f.name} {f.isGift && <Icon icon='gift' />}</div>
                                                    {f.isGift && <SubText>Gifted To: {f.giftedEmail}</SubText>}
                                                </Col>
                                                <div style={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'space-between'
                                                }}>
                                                    <div><b>{f.quantity ?? '1'}</b> x</div> <span>{currency.format(f.unitPrice)}</span>
                                                </div>
                                            </Indent>
                                        ))}
                                </CardWrapper>
                            ).joinComponent(<LineBreak />)}
                    </> :
                    <>
                        You haven't made any purchases yet.
                        <Button to={routes.washes.route}>Buy Some Washes</Button>
                    </>
            }
        </Card>
    );
}

export default PurchaseHistory;